/**
 * File: CheckList.js
 * Origin: isotect
 * Description: CheckList component for forms.
 *
 * Version: v2.0.0
 * Created: 2026-01-12
 * Last Updated: 2026-02-25
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import Checkbox from "./Checkbox";

function CheckList({ heading, checkboxes, selected, setSelected }) {
    const handleChange = (label, isChecked) => {
        setSelected((prev) =>
            isChecked
                ? [...prev, label]
                : prev.filter((item) => item !== label),
        );
    };

    return (
        <>
            <div className="check-list">
                <p>{heading}</p>
                {checkboxes.map((checkbox) => (
                    <Checkbox
                        key={checkbox.id}
                        id={checkbox.id}
                        label={checkbox.label}
                        checked={selected.includes(checkbox.label)}
                        onChange={(isChecked) =>
                            handleChange(checkbox.label, isChecked)
                        }
                    />
                ))}
            </div>
        </>
    );
}

export default CheckList;
